import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { BUSINESS, CATEGORIES } from "../../lib/constants";

export function Footer() {
  return (
    <footer className="bg-black border-t border-amber-500/10 pt-16 pb-8" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-4">
            <img src={BUSINESS.logo} alt={BUSINESS.name} loading="lazy" className="h-10 w-10 rounded-full object-cover" />
            <span className="font-display text-xl text-white tracking-wide">ORION SERVICES</span>
          </div>
          <p className="text-sm text-zinc-400 max-w-sm leading-relaxed">{BUSINESS.tagline}</p>
          <div className="mt-6 space-y-2 text-sm text-zinc-400">
            <div className="flex items-center gap-2" data-testid="footer-phone">
              <Phone className="h-4 w-4 text-amber-light" /> <a href={`tel:${BUSINESS.phoneRaw}`} className="hover:text-amber-light">{BUSINESS.phone}</a>
            </div>
            {BUSINESS.emails.map((e) => (
              <div className="flex items-center gap-2" key={e} data-testid={`footer-email-${e}`}>
                <Mail className="h-4 w-4 text-amber-light" /> <a href={`mailto:${e}`} className="hover:text-amber-light">{e}</a>
              </div>
            ))}
            <div className="flex items-center gap-2" data-testid="footer-address">
              <MapPin className="h-4 w-4 text-amber-light" /> {BUSINESS.address}
            </div>
          </div>
        </div>

        <div>
          <h4 className="font-mono text-xs uppercase tracking-widest text-amber-light mb-4">Categories</h4>
          <ul className="space-y-2">
            {CATEGORIES.map((c) => (
              <li key={c}>
                <Link to={`/catalog?category=${encodeURIComponent(c)}`} className="text-sm text-zinc-400 hover:text-amber-light">
                  {c}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-mono text-xs uppercase tracking-widest text-amber-light mb-4">Company</h4>
          <ul className="space-y-2">
            <li><Link to="/catalog" className="text-sm text-zinc-400 hover:text-amber-light">Full Catalog</Link></li>
            <li><Link to="/custom-orders" className="text-sm text-zinc-400 hover:text-amber-light">Custom Orders</Link></li>
            <li><Link to="/blog" className="text-sm text-zinc-400 hover:text-amber-light">Insights & Guides</Link></li>
            <li><Link to="/quote" className="text-sm text-zinc-400 hover:text-amber-light">Request a Quote</Link></li>
            <li><Link to="/admin/login" className="text-sm text-zinc-400 hover:text-amber-light">Admin Portal</Link></li>
          </ul>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-12 pt-6 border-t border-amber-500/10 text-xs text-zinc-500 font-mono">
        © {new Date().getFullYear()} {BUSINESS.name}. All rights reserved.
      </div>
    </footer>
  );
}
